import TuiGrid from 'tui-grid';
import Vue from 'vue';
import LayerPopup from '@/components/LayerPopup.vue';
import {Grid} from '@toast-ui/vue-grid';
import PageView from '@/views/PageView.vue';

TuiGrid.setLanguage('ko', {
  display: {
    noData: '조회 결과가 없습니다.'
  }
});
// @ts-ignore
TuiGrid.applyTheme('myTheme', {
  outline: {
    showVerticalBorder: true
  },
  scrollbar: {
    border: '#ccc',
    emptySpace: '#f5f5f5',
    background: '#f5f5f5', // 안먹히는것 같음
    thumb: '#d9d9d9', // 不好使啊 active는 잘먹히는데 thumb 는 안먹힘
    active: '#cccccc'
  },
  area: {
    body: {
      background: '#f5f5f5'
    },
    summary: {
      border: '#000'
    }
  },
  cell: {
    normal: {
      background: '#fff',
      border: '#ccc',
      showVerticalBorder: true,
      showHorizontalBorder: true
    },
    header: {
      background: '#e5e5e5',
      border: '#ccc'
    },
    rowHeader: {
      background: '#e5e5e5',
      showVerticalBorder: true, // 안먹힘
      border: '#ccc'
    },
    summary: {
      border: '#000',
      showVerticalBorder: true,
      showHorizontalBorder: true
    }
  }
});

Vue.component('layer-popup', LayerPopup);
Vue.component('grid', Grid);
Vue.component('page', PageView);
